<template>
<div>

    <div class="box box-info" v-if="module == 'employees'">
        <div class="box-body">
            <h4>Formato del archivo .csv de EMPLEADOS</h4>
            <el-table :data="employees_data" border style="width: 100%">
                <el-table-column prop="company_id_number" label="Código"></el-table-column>
                <el-table-column prop="status" label="Estado"></el-table-column>
                <el-table-column prop="first_name" label="Nombres"></el-table-column>
                <el-table-column prop="last_name" label="Apellidos"></el-table-column>
                <el-table-column prop="id_type" label="Tipo cédula"></el-table-column>
                <el-table-column prop="id_number" label="Cédula"></el-table-column>
                <el-table-column prop="title" label="Cargo"></el-table-column>
                <el-table-column prop="labor_agreement_id" label="Ac. laboral"></el-table-column>
                <el-table-column prop="roster_id" label="Nómina"></el-table-column>
            </el-table>
            <div><label>* El archivo debe tener formato .csv (valores separados por punto y comas). NO debe incluir la cabecera con los nombres de los campos, solo debe contener los datos.</label></div>
            <div><label style="width: 85px;">Código: </label>Código interno del empleado (o cédula)</div>
            <div><label style="width: 85px;">Estado: </label>ACT (activo) o DES (inactivo) - Siempre en mayúsculas</div>
            <div><label style="width: 85px;">Tipo cédula: </label>CC, CE, etc.</div>
            <div><label style="width: 85px;">Ac. laboral: </label>Código de acuerdo laboral en LaborTIME para el empleado</div>
            <div><label style="width: 85px;">Nómina: </label>Código de nómina en LaborTIME para el empleado</div>
        </div>
    </div>

    <div class="box box-info" v-if="module == 'employeesfunctionalareas'">
        <div class="box-body">
            <h4>Formato del archivo .csv de EMPLEADOS - ÁREAS</h4>
            <el-table :data="employees_functional_areas_data" border style="width: 100%">
                <el-table-column prop="id_number" label="Cédula"></el-table-column>
                <el-table-column prop="functional_area" label="Área"></el-table-column>
                <el-table-column prop="date_from" label="Desde"></el-table-column>
                <el-table-column prop="date_to" label="Hasta"></el-table-column>
            </el-table>
            <div><label>* El archivo debe tener formato .csv (valores separados por punto y comas). NO debe incluir la cabecera con los nombres de los campos, solo debe contener los datos.</label></div>
            <div><label style="width: 55px;">Área: </label>Código de área en LaborTIME para el empleado</div>
            <div><label style="width: 55px;">Desde: </label>Fecha desde la cual el empleado pertenecerá al área (formato AAAA-MM-DD)</div>
            <div><label style="width: 55px;">Hasta: </label>Fecha hasta la cual el empleado pertenecerá al área (formato AAAA-MM-DD) - Usar 2099-12-31 si es para siempre</div>
        </div>
    </div>

    <div class="box box-info" v-if="module == 'employeesshifts'">
        <div class="box-body">
            <h4>Formato del archivo .csv ó .xlsx de EMPLEADOS - TURNOS</h4>
            <el-table :data="employees_shifts_data" border style="width: 100%">
                <el-table-column prop="id_number" label="Cédula"></el-table-column>
                <el-table-column prop="name" label="Nombre"></el-table-column>
                <el-table-column prop="day1" label="2020-01-20"></el-table-column>
                <el-table-column prop="day2" label="2020-01-21"></el-table-column>
                <el-table-column prop="day3" label="2020-01-22"></el-table-column>
                <el-table-column prop="day4" label="2020-01-23"></el-table-column>
                <el-table-column prop="day5" label="2020-01-24"></el-table-column>
            </el-table>
            <div><label>* El archivo debe tener formato .csv (valores separados por punto y comas) ó .xlsx. DEBE incluir la cabecera con los nombres de los campos y las fechas para las cuales se asignan los turnos.</label></div>
            <div><label>* Se incluye una columna por cada día en formato YYYY-MM-DD. Puede haber cualquier cantidad de días.</label></div>
        </div>
    </div>

    <div class="box box-info" v-if="module == 'employeessalary'">
        <div class="box-body">
            <h4>Formato del archivo .csv de EMPLEADOS - SALARIO</h4>
            <el-table :data="employees_salary_data" border style="width: 100%">
                <el-table-column prop="id_number" label="Cédula"></el-table-column>
                <el-table-column prop="salary" label="Salario mensual"></el-table-column>
                <el-table-column prop="date_from" label="Desde"></el-table-column>
                <el-table-column prop="date_to" label="Hasta"></el-table-column>
            </el-table>
            <div><label>* El archivo debe tener formato .csv (valores separados por punto y comas). NO debe incluir la cabecera con los nombres de los campos, solo debe contener los datos.</label></div>
            <div><label style="width: 55px;">Salario mensual: </label>Valor del salario entero o con hasta dos decimales</div>
            <div><label style="width: 55px;">Desde: </label>Fecha desde la cual el empleado pertenecerá al área (formato AAAA-MM-DD)</div>
            <div><label style="width: 55px;">Hasta: </label>Fecha hasta la cual el empleado pertenecerá al área (formato AAAA-MM-DD) - Usar 2099-12-31 si es para siempre</div>
        </div>
    </div>

    <el-data-table 
        :resourceUrl="baseUrl"
        ref="dataTable">

        <template slot="tableActions">
            <el-upload
            class="upload-demo"
            ref="upload"
            :action="'/api'+baseUrl"
            accept=".csv, .xlsx, .xls"
            :auto-upload="false"
            :headers="headers"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            name="batch_file">
            <el-button slot="trigger" size="small" type="primary">Seleccionar archivo</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Subir archivo</el-button>
            <div class="el-upload__tip" slot="tip">archivos .csv ó .xlsx de hasta 10MB</div>
            </el-upload>
        </template>

        <template slot="columns">
            <el-table-column
                prop="created_at"
                width="160"
                align="center"
                label="Fecha">
            </el-table-column>
            <el-table-column
                prop="original_file_name"
                label="Archivo">
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="Estado">
                <template slot-scope="scope">
                    {{status_codes[scope.row.status]}}
                </template>
            </el-table-column>
            <el-table-column
                prop="error"
                label="Observaciones">
            </el-table-column>
            <el-table-column
                v-if="module == 'employees'"
                width="120"
                label="Acciones">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-tooltip class="item" effect="dark" content="Enviar usuarios a dispositivos enroladores (según área)" placement="top">
                            <el-button size="mini" type="primary" icon="el-icon-download" :plain="true" @click="handleSendToEnrollmentDevices(scope.$index, scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Tomar rostro de dispositivos enroladores (según área)" placement="top">
                            <el-button size="mini" type="primary" icon="el-icon-upload" :plain="true" @click="handleFetchTemplates(scope.$index, scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Enviar rostros a dispositivos (según área)" placement="top">
                            <el-button size="mini" type="primary" icon="el-icon-share" :plain="true" @click="handleSendTemplatesToDevices(scope.$index, scope.row)"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>

            </el-table-column>
        </template>
    </el-data-table>

</div>
</template>

<script>
    import el_data_table from './el-data-table.vue';
    export default {
        data: function() {
            return {
                module: null,
                baseUrl: this.$route.path,
                status_codes: {
                    '0': 'Subido',
                    '1': 'Procesando',
                    '2': 'Ok',
                    '3': 'Error'
                },
                employees_data: [
                    {
                        company_id_number: '123456',
                        status: 'ACT',
                        first_name: 'Juan',
                        last_name: 'Pérez',
                        id_type: 'CC',
                        id_number: '1020485695',
                        title: 'Encargado de planta',
                        labor_agreement_id: 'AL002',
                        roster_id: 'N001'
                    }, {
                        company_id_number: '45245657',
                        status: 'ACT',
                        first_name: 'Mauricio',
                        last_name: 'González',
                        id_type: 'CC',
                        id_number: '1045464567',
                        title: 'Supervisor',
                        labor_agreement_id: 'AL001',
                        roster_id: 'N003'
                    }
                ],
                employees_functional_areas_data: [
                    {
                        id_number: '1020485695',
                        functional_area: 'A001',
                        date_from: '2019-09-20',
                        date_to: '2099-12-31',
                    }, {
                        id_number: '1045464567',
                        functional_area: 'A003',
                        date_from: '2019-09-20',
                        date_to: '2019-10-28',
                    }
                ],
                employees_shifts_data: [
                    {
                        id_number: '79861468',
                        name: 'LUCIA, QUINTERO',
                        day1: '06a14',
                        day2: 'DESCANSO',
                        day3: '14a22',
                        day4: '14a22',
                        day5: '14a22'
                    }, {
                        id_number: '19449639',
                        name: 'CATALINA, VILLAMIL',
                        day1: '10a18',
                        day2: '13a21',
                        day3: '10a18',
                        day4: '13a21',
                        day5: '10a18'
                    }, {
                        id_number: '52161869',
                        name: 'ANTONIO, LOPEZ',
                        day1: 'INCAPACIDAD',
                        day2: 'INCAPACIDAD',
                        day3: '10a20',
                        day4: '10a20',
                        day5: ''
                    }
                ],
                employees_salary_data: [
                    {
                        id_number: '1020485695',
                        salary: 1350800,
                        date_from: '2019-09-20',
                        date_to: '2099-12-31',
                    }, {
                        id_number: '1045464567',
                        salary: 1020500.45,
                        date_from: '2019-09-20',
                        date_to: '2019-10-28',
                    }
                ],
                headers:{
                    'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
        },
        components: {
            'el-data-table': el_data_table
        },
        watch: {
            '$route': function (to) {
                this.baseUrl = to.path;
                this.module = to.params.type;
            }
        },
        mounted() {
            this.module = this.$route.params.type;
        },
        methods: {
            submitUpload() {
                this.$refs.upload.submit();
            },
            uploadSuccess(response, file, fileList) {
                this.$refs.upload.clearFiles();
                this.$refs.dataTable.fetchItems();
            },
            uploadError(response, file, fileList) {
                this.$refs.upload.clearFiles();
                this.$refs.dataTable.fetchItems();
            },
            handleSendToEnrollmentDevices(idx, row) {
                this.$confirm('Esto enviará los datos de los empleados del archivo a los dispositivos que les correspondan según el área asignada para ser enrolados. Si el empleado ya estuviera enrolado se le eliminará la plantilla del rostro.', 'Alerta', {
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    axios.post('/api/batchprocesses/employees/sendtoenrollmentdevices', {batch_process_id: row.id})
                    .then(response => {
                        this.$notify({
                            title: 'Operación en proceso',
                            type: 'info',
                            message: 'Enviando información a los dispositivos'
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            _.each(error.response.data, (value, key) => {
                                this.errors[key] = value.join(", ");
                            });
                        }
                    });
                });          
            },
            handleFetchTemplates(idx, row) {
                axios.post('/api/batchprocesses/employees/fetchtemplates', {batch_process_id: row.id})
                .then(response => {
                    this.$notify({
                        title: 'Operación en proceso',
                        type: 'info',
                        message: 'Tomando rostros de los dispositivos'
                    });
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        _.each(error.response.data, (value, key) => {
                            this.errors[key] = value.join(", ");
                        });
                    }
                });
            },
            handleSendTemplatesToDevices(idx, row) {
                axios.post('/api/batchprocesses/employees/sendtemplatestodevices', {batch_process_id: row.id})
                .then(response => {
                    this.$notify({
                        title: 'Operación en proceso',
                        message: 'Replicando rostros a los dispositivos',
                        type: 'info'
                    });
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        _.each(error.response.data, (value, key) => {
                            this.errors[key] = value.join(", ");
                        });
                    }
                });
            }
        }
    }
</script>
